var { positionTop, resizeObserver } = require("./utils");
var {
    hideHeaderBanner,
    menuAccessibility,
    keyboardAccessibilityFunctions,
    handleNavSubscribeClick,
    toggleNavbar,
    clearSelection,
    clearAllSelectionOnClose
} = require("./menuHelpers");
var isTransparentHeader = $(".transparent-header").length;
var isContentCarousel = $(".js-content-carousel").length;
var $headerBar = $(".header-bar");
var $headerContent = $(".header-content");
var $window = $(window);

/**
 * Promo Bar resize observer callback sets data-promoHeight to the header and reposition it
 * @param {Number} promoHeight - Height of the promobanner
 */
function promoBarHeightObserver(promoHeight) {
    $headerContent.data("promoHeight", promoHeight);
    positionHeader();
}

/**
 * Set top value of transparent header based on promobanner height and sticky header
 */
function positionHeader() {
    if ($window.scrollTop() <= 100) {
        positionTop($headerContent, $headerContent.data("promoHeight"));
    } else {
        positionTop($headerContent);
    }
}

module.exports = function () {
    var isDesktop = function (element) {
        return $(element).parents(".menu-toggleable-left").css("position") !== "fixed";
    };

    if (isTransparentHeader && isContentCarousel) {
        const promoBarObserver = resizeObserver(promoBarHeightObserver);
        promoBarObserver.observe($headerBar[0]);

        $window.on("scroll", function () {
            positionHeader();
        });
    }

    hideHeaderBanner();
    menuAccessibility();

    $(".dropdown:not(.disabled) [data-toggle=\"dropdown\"]")
        .on("click", function (e) {
            if (!isDesktop(this)) {
                e.preventDefault();
                var li = $("<li class=\"dropdown-item top-category\" role=\"button\"></li>");
                var link = $(this).clone().removeClass("dropdown-toggle")
                    .removeAttr("data-toggle")
                    .removeAttr("aria-expanded")
                    .attr("aria-haspopup", "false");
                li.append($(".back").first().clone());
                li.append(link);
                $(this).parent().children(".dropdown-menu").prepend(li);
                $(".modal-background").show();
                $(this).parent().addClass("show");
                $(this).attr("aria-expanded", "true");
                $("div.menu-group > ul.nav.navbar-nav > li.nav-item > a").attr("aria-hidden", "true");
            }
        })
        .on("mouseenter", function () {
            if (isDesktop(this)) {
                var eventElement = this;
                $(".navbar-nav > li").each(function () {
                    if (!$.contains(this, eventElement)) {
                        $(this).find(".show").each(function () {
                            clearSelection(this, true);
                        });
                        if ($(this).hasClass("show")) {
                            $(this).removeClass("show");
                            $(this).children("ul.dropdown-menu").removeClass("show");
                            $(this).children(".nav-link").attr("aria-expanded", "false");
                        }
                    }
                });
                // need to close all the dropdowns that are not direct parent of current dropdown
                $(this).parent().addClass("show");
                $(this).siblings(".dropdown-menu:not(.dropdown-submenu)").addClass("show");
                $(this).attr("aria-expanded", "true");
            }
        })
        .parent()
        .on("mouseleave", function () {
            if (isDesktop(this)) {
                $(this).removeClass("show");
                $(this).children(".dropdown-menu").removeClass("show");
                $(this).children(".nav-link").attr("aria-expanded", "false");
            }
        });

    $(".js-close-menu").on("click", function (e) {
        e.preventDefault();
        clearAllSelectionOnClose();
        $(".navbar-nav").find(".show").removeClass("show");
        $("body").removeClass("menu-active");
        $(".menu-toggleable-left").removeClass("in");
        $(".modal-background").hide();
        $(".main-menu").attr("aria-hidden", "true");
        $(".main-menu").siblings().attr("aria-hidden", "false");
        $("header").siblings().attr("aria-hidden", "false");
        if (isTransparentHeader && isContentCarousel && !$(".header-content").hasClass("sticky-head")) {
            positionTop($headerContent, $headerContent.data("promoHeight"));
        }
    });

    $(".navbar-nav").on("click", ".back", function (e) {
        e.preventDefault();
        clearSelection(this, true);
    });

    $(".navbar-toggler").click(function (e) {
        toggleNavbar(e);

        if (isTransparentHeader && isContentCarousel) {
            positionTop($headerContent, $window.scrollTop() <= 100 ? $window.scrollTop() : 0);
        }
    });

    keyboardAccessibilityFunctions();
    handleNavSubscribeClick(false);
};
